/* eslint-disable no-unused-vars */

import { useCallback, useContext, useEffect, useState } from "react";

import { ModalRefusedOrder } from "../../components/Modals/RefusedOrder";
import { NavBar } from "../../components/NavBar";
import { OrderContext } from "../../context/OrderContext";
import _ from "lodash";

import "./style.css";
import { RouteMaps } from "../../components/Modals/RouteMaps";
import { FaCashRegister, FaLocationArrow } from "react-icons/fa";
import { useCompany } from "../../hooks/useCompany";
import { TableComponent } from "../../components/Tables";
import { GlobalContext } from "../../context/GlobalContext";
import { Toast } from "../../utils/Toast";
import { api } from "../../api/api";
import useSWR from "swr";
import { ModalOrderIfood } from "../../components/Modals/OrderIfood";
import { useNavigate } from "react-router-dom";
import { SocketContext } from "../../context/SocketContext";
import { ListaPedidos } from "./components/lista-pedidos";
import { TypePayment } from "../../utils/utils";
import { FiHelpCircle, FiPlus, FiShoppingBag, FiGrid, FiRefreshCw, FiWifiOff } from "react-icons/fi";
import { OrderUpdatesTour } from "../../components/Modals/OrderUpdatesTour";

const ORDER_UPDATES_RELEASE = "orders-redesign-guide-v2-2026-08";

export function HomePage() {
  const [tab, setTab] = useState('pedidos')
  const { isAccess, user, openModalOrder } = useContext(GlobalContext);
  const [countTables, setCountTables] = useState(0);
  const { orders, selectOrder } = useContext(OrderContext);
  const { loading: loadingSocket, error: socketError, retry: retrySocket } = useContext(SocketContext);

  const { configurations, company } = useCompany();
  const navigate = useNavigate();

  const [orderIfood, setOrderIfood] = useState({});
  const [updatesTourOpen, setUpdatesTourOpen] = useState(false);
  const [updatesTourFlow, setUpdatesTourFlow] = useState("orders");

  const { data: dataProductsNotSeen } = useSWR(
    "/product-order/products/not-seen",
    async () => {
      if (isAccess() === "garcom") {
        return;
      }

      const response = await api.get("/product-order/products/not-seen");

      const bodyProductNotSeen = response.data;
      const groupNumOrder = _.groupBy(bodyProductNotSeen, "numOrder");
      const groupedByName = _.groupBy(
        bodyProductNotSeen.filter((k) => k.name),
        "name"
      );
      const groupedByIdOrder = _.groupBy(
        bodyProductNotSeen.filter((k) => k.name),
        "idOrder"
      );

      if (bodyProductNotSeen.length > 0) {
        if (configurations?.sound) {
          document.getElementById("audio-new-order").play();
        }
      }

      return {
        groupNumOrder,
        groupedByName,
        groupedByIdOrder,
      };
    },
    {
      refreshInterval: 15000,
      refreshWhenHidden: false,
      revalidateOnFocus: false,
    }
  );

  const { data: safeIsOpen } = useSWR(
    "/safe/is/open",
    async () => {
      const res = await api.get("/safe/is/open");

      return res.data;
    },
    {}
  );

  async function createOrder() {
    if (!isAccess("pedidos", "create_pedido_balcao")) {
      return Toast.warning(
        "Você não tem permissão para criar um pedido de balcão."
      );
    }
    const confirmation = await Toast.whenTypeOrder(
      "Criar pedido?",
      "Não",
      "Sim"
    );

    if (confirmation === true) {
      // entrega imediata
      const response = await api.post("/orders", {
        methodDelivery: "retirada",
        name: "Pedido balcão",
        phone: "",
        status: "aprovado",
        typeOrder: "frente-de-caixa",
        paymentMethod: TypePayment.money,
      });

      await selectOrder(response.data.id);

      openModalOrder();
      return;
    }
  }

  const updatesTourUserKey = user.id || user.email;
  const updatesTourStorageKey = updatesTourUserKey
    ? `order-updates-tour:${updatesTourUserKey}:${ORDER_UPDATES_RELEASE}`
    : null;

  const closeUpdatesTour = useCallback(() => {
    setUpdatesTourOpen(false);
    if (updatesTourStorageKey) {
      const closeCount = Number(localStorage.getItem(updatesTourStorageKey)) || 0;
      localStorage.setItem(updatesTourStorageKey, String(Math.min(closeCount + 1, 3)));
    }
  }, [updatesTourStorageKey]);

  useEffect(() => {
    if (!updatesTourStorageKey) return;

    const closeCount = Number(localStorage.getItem(updatesTourStorageKey)) || 0;
    if (closeCount >= 3) return;

    setUpdatesTourFlow(user.typeUser === "garcom" ? "tables" : "orders");
    setUpdatesTourOpen(true);
  }, [updatesTourStorageKey, user.typeUser]);

  useEffect(() => {
    if (document.getElementById("contractHome")) {
      new window.bootstrap.Modal(
        document.getElementById("contractHome"),
        {}
      ).toggle();
    }

  }, []);

  useEffect(() => {
    if (orderIfood?.id) {
      new window.bootstrap.Modal(
        document.getElementById("modalOrderIfood"),
        {}
      ).toggle();
    }
  }, [orderIfood]);

  useEffect(() => {
    // Adiciona evento global para verificar clicks no backdrop
    const handleBackdropClick = (e) => {
      const backdrop = e.target.classList.contains("modal-backdrop");
      const modalOpen = document.querySelector(".modal.show");

      if (backdrop && !modalOpen) {
        // Remove backdrop órfão
        document
          .querySelectorAll(".modal-backdrop")
          .forEach((el) => el.remove());
        document.body.classList.remove("modal-open"); // Remove scroll-lock
        document.body.style = ""; // Limpa inline styles
      }
    };

    // Listener global
    document.addEventListener("click", handleBackdropClick);

    return () => {
      document.removeEventListener("click", handleBackdropClick);
    };
  }, []);

  useEffect(() => {
    if (company.id) {
      if (!company.whatsapp || !company.city || !company.uf || !company.address || !company.city || !company.district) {
        Toast.message('Favor realizar a configuração inicial, para continuar!')
        navigate('/company')
      }
    }
    if (configurations.id) {
      if (!configurations.methodDelivery) {
        Toast.message('Favor realizar a configuração inicial na parte de (Personalização), para continuar!')
        navigate('/company')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company, configurations])

  function openUpdatesTour() {
    setUpdatesTourFlow(tab === "mesas" || user.typeUser === "garcom" ? "tables" : "orders");
    setUpdatesTourOpen(true);
  }

  const currentDate = new Intl.DateTimeFormat('pt-BR', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
  }).format(new Date())

  return (
    <>
      <OrderUpdatesTour open={updatesTourOpen} onClose={closeUpdatesTour} initialFlow={updatesTourFlow} />
      <ModalRefusedOrder />
      {user.plan === "complet" && (
        <ModalOrderIfood order={orderIfood} clear={() => setOrderIfood({})} />
      )}
      {configurations.googleKey && user.plan === "complet" && <RouteMaps />}
      <NavBar>
        {loadingSocket && !socketError && (
          <div
            className="container-fluid"
            style={{ height: "100vh", width: "100vw" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <div
                className="spinner-border text-success"
                role="status"
                style={{ width: 50, height: 50 }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        )}
        {socketError && (
          <div className="home-socket-error-page">
            <div className="home-socket-error-card">
              <span className="home-socket-error-icon"><FiWifiOff /></span>
              <h2>Não foi possível carregar os pedidos</h2>
              <p>{socketError}</p>
              <button type="button" onClick={retrySocket}><FiRefreshCw /> Tentar novamente</button>
            </div>
          </div>
        )}
        {!loadingSocket && !socketError && (
          <>
            {isAccess() !== "garcom" && (
              <>
                <main className="home-dashboard">
                  <header className="home-page-header">
                    <div>
                      <h1>Pedidos</h1>
                      <p className="home-page-date">{currentDate} · acompanhe a operação da sua loja</p>
                    </div>

                    <div className="home-primary-actions">
                      <button type="button" className="home-action-button home-action-button-light" onClick={openUpdatesTour}>
                        <FiHelpCircle size={17} />
                        <span>Ajuda</span>
                      </button>

                      {configurations.googleKey && user.plan === "complet" && (
                        <button
                          type="button"
                          className="home-action-button home-action-button-light"
                          data-bs-toggle="modal"
                          data-bs-target="#modalRoutesMaps"
                        >
                          <FaLocationArrow size={15} />
                          <span>Rotas</span>
                        </button>
                      )}

                      <button type="button" className="home-action-button home-action-button-light" onClick={() => navigate("/safe")}>
                        <FaCashRegister size={16} color={safeIsOpen ? "#dc2626" : "#16a34a"} />
                        <span>Caixa</span>
                      </button>

                      {tab === 'pedidos' && isAccess("pedidos", "create_pedido_balcao") && (
                        <button type="button" className="home-action-button home-action-button-primary" onClick={createOrder}>
                          <FiPlus size={18} />
                          <span>Novo pedido</span>
                        </button>
                      )}
                    </div>
                  </header>

                  {localStorage.getItem("message") !== 'null' && localStorage.getItem("message") && (
                    <div className="home-plan-alert" role="status">
                      <span className="home-plan-alert-icon">!</span>
                      <span>{localStorage.getItem("message")}</span>
                    </div>
                  )}

                  <div className="home-tabs-row">
                    <div className="home-tabs" role="tablist" aria-label="Visualização da operação">
                      <button
                        type="button"
                        role="tab"
                        aria-selected={tab === 'pedidos'}
                        className={`home-tab ${tab === 'pedidos' ? 'active' : ''}`}
                        onClick={() => setTab('pedidos')}
                      >
                        <FiShoppingBag size={16} />
                        <span>Pedidos / iFood</span>
                        <strong>
                          {orders?.filter(e => ['delivery', 'frente-de-caixa'].includes(e.typeOrder)).length || 0}
                        </strong>
                      </button>

                      <button
                        type="button"
                        role="tab"
                        aria-selected={tab === 'mesas'}
                        className={`home-tab ${tab === 'mesas' ? 'active' : ''}`}
                        onClick={() => setTab('mesas')}
                      >
                        <FiGrid size={16} />
                        <span>Mesas</span>
                        <strong>{countTables}</strong>
                      </button>
                    </div>
                  </div>

                  <div className="home-tab-panel" style={{ display: tab === 'pedidos' ? 'block' : 'none' }}>
                    <ListaPedidos setOrderIfood={setOrderIfood} dataProductsNotSeen={dataProductsNotSeen} />
                  </div>

                  <div className="home-tab-panel" style={{ display: tab === 'mesas' ? 'block' : 'none' }}>
                    <TableComponent
                      setCountTables={setCountTables}
                      dataProductsNotSeen={dataProductsNotSeen}
                    />
                  </div>
                </main>
              </>
            )}

            {isAccess() === "garcom" && (
              <div className="home-waiter-view">
                <button type="button" className="home-waiter-help" onClick={openUpdatesTour}>
                  <FiHelpCircle size={17} />
                  <span>Novidades</span>
                </button>
                <TableComponent
                  setCountTables={setCountTables}
                  dataProductsNotSeen={dataProductsNotSeen}
                />
              </div>
            )}
          </>
        )}
      </NavBar>
    </>
  );
}
